import { useEffect } from 'react';

import { usePdpContext } from '../../pdp-provider';

const useMoveFocus = ({ elementRef, productOptionNumber }) => {
  const { moveFocusToNewPicker, setMoveFocusToNewPicker } = usePdpContext();

  useEffect(() => {
    if (moveFocusToNewPicker && moveFocusToNewPicker === productOptionNumber) {
      elementRef?.current?.focus?.();
      // clear out the state so we don't focus again!
      setMoveFocusToNewPicker(null);
    }
  }, []);
};

export default useMoveFocus;
